import { createFileRoute } from '@tanstack/react-router'

import Footer from '@/components/landing/footer'
import Navbar from '@/components/landing/navbar'
import WhatsAppFloatingButton from '@/components/ui/whatsapp-floating'

import ApplicationProcess from './-components/application-process'
import HeroSection from './-components/hero'
import JobCategories from './-components/job-category'
import PreparationStep from './-components/preparation-step'
import PricingSection from './-components/pricing-section'
import ProgramPhase from './-components/program-phase'
import StudentTestimonials from './-components/student-testimonial'
import WhyJapan from './-components/why-japan'

export const Route = createFileRoute('/program/gijinkoku-preparation/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <div className="min-h-screen font-poppins">
        <Navbar className="relative" />
        <HeroSection />
        <WhyJapan />
        <JobCategories />
        <ProgramPhase />
        <StudentTestimonials />
        <PreparationStep />
        <ApplicationProcess />
        <PricingSection />
        <WhatsAppFloatingButton />
        <Footer />
      </div>
    </>
  )
}
